module.exports = __webpack_public_path__ + "img/part4-item-bg-over4.7aa962cf.png";